import React from 'react';

import { View } from '@dbk/ui-react-utils';

import Svg, { G, Path } from '@dbk/ui-svg';

const SearchWithoutCircle = ({ fill = 'white', width = 20, height = 20, scale = 1, style }) => (
  <View style={style}>
    <Svg width={width} height={height}>
      <Path
        fill={fill}
        d="M7.89554977,2.99208034e-14 C3.54120671,2.99208034e-14 0,3.5412015 0,7.8955851 C0,12.2499108 3.54120671,15.7911597 7.89554977,15.7911597 C9.88299124,15.7911597 11.6959674,15.0497642 13.085242,13.8337125 L19.1055987,19.8458584 C19.3111725,20.0513542 19.6402327,20.0514068 19.8457802,19.8458584 C20.0513803,19.6402837 20.0514329,19.3111431 19.8457802,19.1056473 L13.8336612,13.0935014 C15.0521024,11.7036679 15.7910995,9.88520938 15.7910995,7.8955851 C15.7910995,3.54119887 12.2498665,0 7.89554977,0 Z M8,1 C11.8723192,1 15,4.12762664 15,8.00000538 C15,11.8723168 11.8723192,15 8,15 C4.12765385,15 1,11.8723168 1,8.00000538 C1,4.12762394 4.12765385,1 8,1 Z"/>
    </Svg>
  </View>
);

export default SearchWithoutCircle;
